import { Box, Paper, Typography, Skeleton } from '@mui/material'
import React from 'react'
import BodyHeader from '../molecules/BodyHeader'
import CardLeftRight from '../molecules/CardLeftRight'
import Figures from '../molecules/Figures'
import TitleSubtitle from '../molecules/TitleSubtitle'
import Zone from '../organisms/Zone'
import strips from '../../media/strips.svg'
import chairSun from '../../media/chair-sun.svg'

import BodyCard from '../atoms/BodyCard'

import useGiftObject from '../../hooks/useGiftObject'
import { CATEGORIES, SERVICES } from '../../constants'
import useFigures from '../../hooks/useFigures'
import useDefault from '../../hooks/useDefault'
import useDefaultLeftRight from '../../hooks/useDefaultLeftRight'

import instaSrc from '../../media/insta_button_icon.svg'
import chairIcon from '../../media/chair_green_icon.svg'
const GiftObject = () => {
	const { isLoading, title, content } = useGiftObject()
	const { figures } = useFigures(CATEGORIES.FIGURES.DON.id)

	const { data: animations } = useDefault(SERVICES.ANIMATION)
	const { data: infos } = useDefaultLeftRight(SERVICES.INFO)
	return (
		<>
			{(isLoading && <Skeleton />) || <BodyHeader title={title}>{content}</BodyHeader>}

			{infos && (
				<Zone color="white">
					<TitleSubtitle title="Infos pratiques" subtitle="Comment et quoi donner ?" />
					{infos.map(({ id, type, slug, title, content }, index) => (
						<Box key={index}>
							<Typography
								sx={(theme) => ({
									color: 'text.primary',
									textAlign: 'left',
									fontSize: 18,
									mt: 4,
									display: 'flex',
									width: '100%',
									flexFlow: (index % 2 === 0 && 'row-reverse wrap') || 'row wrap',
									fontFamily: 'montserrat',
									justifyContent: 'space-between',
									px: 2,

									[theme.breakpoints.down('md')]: {
										mt: 2,
									},

									'& figure': {
										pt: 4,
										m: 0,
										display: 'flex',
										justifyContent: (index % 2 === 1 && 'flex-start') || 'flex-end',
										flexBasis: '47%',

										[theme.breakpoints.down('md')]: {
											pt: 0,
											flexBasis: '100%',
										},

										'& img': {
											display: 'block',
											overflow: 'hidden',
											borderRadius: '8px',
											height: 'fit-content',
											width: '100%',

											[theme.breakpoints.down('md')]: {
												width: '100%',
											},
										},
									},

									'& em': {
										fontSize: 16,
									},

									'& a': {
										color: 'secondary.main',
										fontWeight: 'bold',
									},

									'& h2': {
										fontSize: 22,
										fontWeight: 800,
										color: 'text.primary',
										mb: 2,
										background: (theme) => `url(${chairIcon}) no-repeat ${theme.spacing(0, 1)}`,
										pl: 4.5,
										display: 'table',
										[theme.breakpoints.down('md')]: {
											fontSize: 19,
											backgroundPositionY: 6,
											backgroundSize: 15,
											pl: 3,
											fontWeight: 900,
										},
									},
									'& pre': {
										borderLeft: `4px solid ${theme.palette.secondary.main}`,
										pl: 2,
										fontWeight: 700,
										fontFamily: 'montserrat',
										[theme.breakpoints.up('md')]: {
											p: theme.spacing(0, 0, 0, 2),
										},
										'& .MuiTypography-root': {
											[theme.breakpoints.down('md')]: {
												fontSize: 16,
											},
										},
									},
									'& blockquote': {
										m: 0,
										my: 2,
										fontSize: 22,
										'& p': {
											fontWeight: 'bold',
											mb: 0,
										},

										'& cite': {
											fontSize: 16,
											fontWeight: 400,
											position: 'relative',
											fontStyle: 'normal',
											textAlign: 'right',
											display: 'block',
										},
									},

									'& .wp-block-group': {
										flexBasis: '47%',

										[theme.breakpoints.down('md')]: {
											flexBasis: '100%',
										},
									},

									'& .wp-block-buttons': {
										display: 'flex',
										justifyContent: 'space-around',

										'& .wp-block-button:nth-of-type(2) a': {
											backgroundColor: 'white',
											color: 'secondary.main',
											textDecoration: 'none',

											background: `white url(${instaSrc}) no-repeat bottom 8px right 15px`,
											pr: 6,
										},
									},

									'& .wp-block-button__link': {
										fontFamily: 'museomoderno',
										cursor: 'pointer',
										position: 'relative',
										display: 'inline-block',
										borderRadius: '28px',
										fontSize: 16,
										p: theme.spacing(1, 2),
										bgcolor: 'secondary.main',
										color: 'white',
										fontWeight: 700,
										my: theme.spacing(2),
										minWidth: 169,
										border: `3px solid ${theme.palette.secondary.main}`,

										'&:hover': {
											bgcolor: 'secondary.main',
											border: `3px solid ${theme.palette.secondary.main}`,
										},

										[theme.breakpoints.down('md')]: {
											display: 'flex',
											m: theme.spacing(0, 'auto'),
											mt: 10,

											'& a': {
												display: 'flex',
												p: 3,
												border: 'none',
											},
										},
									},
								})}
								component="div"
								dangerouslySetInnerHTML={{ __html: content }}
							/>
						</Box>
					))}

					{animations?.list?.map(({ id, title, srcset, image, content, acfType }) => (
						<Box
							key={id}
							sx={(theme) => ({
								mt: 10,
								[theme.breakpoints.down('md')]: {
									mt: 6,
								},
							})}
						>
							<TitleSubtitle title={acfType} subtitle={title} />
							<CardLeftRight hasRightTitle bgcolor="white" src={srcset} image={image}>
								<BodyCard>
									<Typography dangerouslySetInnerHTML={{ __html: content }} />
								</BodyCard>
							</CardLeftRight>
						</Box>
					))}
				</Zone>
			)}

			<Paper
				sx={(theme) => ({
					bgcolor: 'primary.main',
					borderRadius: 0,
					textAlign: 'center',
					p: (theme) => theme.spacing(16, 14),
					backgroundImage: `url(${strips})`,
					backgroundRepeat: 'round no-repeat',

					[theme.breakpoints.down('md')]: {
						p: theme.spacing(10, 3),
						backgroundRepeat: 'no-repeat',
					},
				})}
			>
				<img
					src={chairSun}
					alt="Le cycle du réemploi solidaire"
					style={{ width: '40%', maxWidth: 200 }}
				/>
				<Typography
					sx={(theme) => ({
						fontWeight: 700,
						fontSize: 18,
						px: 10,
						mt: 2,
						lineHeight: 1.2,
						[theme.breakpoints.down('md')]: {
							px: 0,
							mt: 4,
							fontSize: 16,
						},
					})}
				>
					Chaque année en France 8 millions de tonnes de nos déchets ménagers assimilés sont enfouis
					ou incinérés <br />
					alors qu'ils pourraient être réemployés en l'état !
				</Typography>
				<Typography sx={{ fontWeight: 400, fontSize: 16, mt: 1 }}>Ademe, étude de 2016</Typography>
			</Paper>
			<Paper
				sx={(theme) => ({
					bgcolor: 'text.primary',
					borderRadius: 0,
					textAlign: 'center',
					p: (theme) => theme.spacing(10, 14),

					[theme.breakpoints.down('md')]: {
						p: theme.spacing(10, 3),
					},
				})}
			>
				<TitleSubtitle
					subtitle="Le don d’objets en chiffres"
					title="depuis 2012"
					color="white"
					titleColor="white"
					inverseTitle
				/>
				{figures && <Figures list={figures} />}
			</Paper>
		</>
	)
}

export default GiftObject
